import * as React from 'react';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

const BookAppointmentCTA = ({ onNavigate , href , className  })=>{
    const { getLabel  } = useIntl();
    const handleClick = React.useCallback(()=>onNavigate && onNavigate()
    , []);
    if (!href) {
        console.error('No href link available for BookAppointmentCTA!');
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        className: className,
        href: href,
        "data-t": "btn-book-appointment",
        caption: getLabel('products.actions.bookAppointment'),
        onClick: handleClick
    });
};

export { BookAppointmentCTA };
//# sourceMappingURL=BookAppointmentCTA.js.map
